import React, { useEffect } from "react";
import { useCommon } from "../../contexts/common";
import { Box, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { trackClickEvent } from "../../mixpanel";

const Footer = ({ step }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { releaseVersion, fetchReleaseVersion } = useCommon();

  useEffect(() => {
    // Only fetch if releaseVersion is empty
    if (!releaseVersion || releaseVersion.length === 0) {
      const fetchRelease = async () => {
        try {
          await fetchReleaseVersion();
        } catch (error) {
          console.error("Error fetching release version:", error);
        }
      };
      fetchRelease();
    }
  }, [releaseVersion, fetchReleaseVersion]);

  return (
    <Box
      sx={{
        textAlign: "center",
        pb: 3.25,
      }}
      component="footer"
    >
      <div className="hideSmall">
        <Typography sx={{ padding: "2px 20px" }} variant="body2">
          <Typography variant="body2" color="text.secondary" component="span">
            ©{new Date().getFullYear()} Trusted Therapist Network™
            {releaseVersion &&
            releaseVersion.environment === "production" &&
            releaseVersion.version
              ? ` · ${releaseVersion.version}`
              : ""}
            <Typography>
              <a
                href={`${window.location.origin}/public/privacy`}
                target="_blank"
                onClick={() =>
                  trackClickEvent("Clicked Footer Link", {
                    component: "Footer Privacy Policy link",
                    page: "Main Layout",
                  })
                }
              >
                Privacy Policy
              </a>
              {" | "}
              <a
                href={`${window.location.origin}/public/terms`}
                target="_blank"
                onClick={() =>
                  trackClickEvent("Clicked Footer Link", {
                    component: "Footer Terms link",
                    page: "Main Layout",
                  })
                }
              >
                Terms of Use
              </a>
              {" | "}
              <a
                href="mailto:team@thettn.com"
                onClick={() =>
                  trackClickEvent("Clicked Footer Link", {
                    component: "Footer Contact Us link",
                    page: "Main Layout",
                  })
                }
              >
                Contact Us
              </a>
              {" | "}
              <a
                href="mailto:team@thettn.com"
                onClick={() =>
                  trackClickEvent("Clicked Footer Link", {
                    component: "Footer Feedback link",
                    page: "Main Layout",
                  })
                }
              >
                Feedback
              </a>
            </Typography>
          </Typography>
        </Typography>
      </div>
      {/* ... rest of your component */}
    </Box>
  );
};

export default Footer;
